import Badge, { badgeColorData } from '@/src/components/atom/Badge';

interface Props {
  options: {
    label: string;
    value: string;
    color: keyof typeof badgeColorData;
  }[];
  value: string;
}

const BadgeOptions = ({ options, value }: Props) => {
  const target = options.find(item => item.value === value) || {
    label: '-',
    color: 'lightGray',
  };

  return <Badge badgeColor={target.color}>{target.label}</Badge>;
};

export default BadgeOptions;
